export const GET_DOCUMENT_CATEGORIES = 'GET_DOCUMENT_CATEGORIES'
export const GET_BOARD_DOCUMENTS = 'GET_BOARD_DOCUMENTS'
export const GET_BOARD_TASK_MAIN_DOCUMENTS = 'GET_BOARD_TASK_MAIN_DOCUMENTS'
export const GET_TASK_DOCUMENTS = 'GET_TASK_DOCUMENTS'
export const GET_TASKMAP_DOCUMENTS = 'GET_TASKMAP_DOCUMENTS'
